import { useEffect, useState } from "react";

/**
 * Whether the visitor has asked their system for less motion.
 *
 * Defaults to `false` so nothing regresses when the query is unavailable, and
 * re-reads on change: someone who turns the preference on mid-session gets a
 * still frame without reloading.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReduced(mql.matches);
    mql.addEventListener("change", onChange);
    setReduced(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
